exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".settings-panel[data-v-ac0ccb4c]{border:1px solid #ccc;padding:10px;border-radius:5px}.settings-label[data-v-ac0ccb4c]{color:#999;margin:0}\n", ""]);

